import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormField } from '../../models/form-field.model';

@Component({
  selector: 'app-edit-field-dialog',
  templateUrl: './edit-field-dialog.component.html',
  styleUrl: './edit-field-dialog.component.scss'
})
export class EditFieldDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FormField,
    private dialogRef: MatDialogRef<EditFieldDialogComponent>
  ) {
    console.log(this.data)
  }

  save() {
    this.dialogRef.close(this.data); // Trả dữ liệu về
  }
}
